<div class="loading">
    <p class="loading-icon"><i class="fa fa-spinner fa-spin"></i></p>
    <h1 class="loading-message">Company Information Loading...</h1>
</div>